import Banner from "../../../assets/images/haugerud-cover.jpg";
import BannerTwo from "../../../assets/images/cover2.webp";


export function MainCover() {
  // function handleOrderButton() {
  //   window.open("https://tista-sushi.orderintelligence.no/", "_blank");  }
  return (
    <div className="relative h-screen">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-50"
        style={{ backgroundImage: `url(${Banner})` }}
      ></div>
      <div className="absolute left-1/2 transform -translate-x-1/2 w-full md:w-3/4  top-28 flex-col items-center mx-auto">
        {" "}
        <p className="p-5 text-3xl text-center lg:w-3/4 mx-auto">
          "Velkommen, hvor autentiske smaker og ferske ingredienser bringer
          essensen av Asia til din tallerken."
        </p>
        {/* <div className="text-center mt-12">
            <SecondaryButton label="Online Bestilling" onClick={handleOrderButton} />
          </div> */}
      </div>
    </div>
  );
}
export function CoverTwo() {
 
  return (
    <div >
     <img src={BannerTwo} alt="haugerud sushi" />
    
   
  
    </div>
  );
}
